import React, { Component } from "react";
import { connect } from "react-redux";
import { withTheme } from "styled-components";
import { Popover } from "@vitalsource/vstui/labs";
import { Account as AccountIcon } from "../icons";
import { t } from "../../../../core/translate";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import {
  actions as userActions,
  selectors as userSelectors
} from "../../../../../redux/user";
import {
  userInfo,
  devices,
  resources,
  pod,
  completeAccount,
  optOut,
  signout,
  languages,
  subscriptions,
  cookieSettings
} from "../menu-items/account";
import {
  support,
  privacy,
  terms,
  about,
  feedback,
  noticeCollection
} from "../menu-items/help";
import {
  ThemedList,
  ThemedButton,
  CurrentUser,
  FullName,
  Email
} from "./styles";

export class AccountMenu extends Component {
  _isFullAccountUser() {
    return (
      !this.props.ssoOnly &&
      this.props.currentUser &&
      !this.props.currentUser.ssoOnly
    );
  }

  _showMe() {
    const {
      currentUser: { firstName, lastName, email }
    } = this.props;

    if (this._isFullAccountUser()) {
      return (
        <CurrentUser>
          <FullName>
            {firstName} {lastName}
          </FullName>
          <Email>{email}</Email>
        </CurrentUser>
      );
    }
  }

  _myAccount() {
    return {
      header: t("base.account-plain", "Account"),
      type: "radioGroup",
      listItems: [
        userInfo(),
        devices(),
        resources(),
        subscriptions(),
        languages(),
        pod(),
        completeAccount(),
        optOut(),
        cookieSettings(),
        signout()
      ].filter(el => !!el)
    };
  }

  _help() {
    return {
      header: t("base.help", "Help"),
      type: "radioGroup",
      listItems: [
        support(),
        privacy(),
        noticeCollection(),
        terms(),
        about(),
        feedback()
      ].filter(el => !!el)
    };
  }

  render() {
    if (this.props.loading) {
      return null;
    }

    return (
      <Popover
        content={
          <div>
            {this._showMe()}
            <ThemedList
              data={[this._myAccount(), this._help()].filter(el => !!el)}
            />
          </div>
        }
      >
        <ThemedButton
          color="white"
          colorBehindButton={props =>
            props.theme.vstui.color.secondary.getShade(7)
          }
          iconStart={<AccountIcon />}
          label={t("global-bar.account", "Account Settings")}
          tooltipPlacement="bottom"
          naked
        />
      </Popover>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: userSelectors.getUser(state),
  loading: userSelectors.isUserFetching(state),
  ssoOnly: brandSelectors.getBrandValue(state, "AccountCompletion.ssoOnly")
});

const mapDispatchToProps = dispatch => ({
  signOut: (user, dest) => dispatch(userActions.signOut(user, dest))
});

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(AccountMenu)
);
